import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import Select from 'components/custom/Select';
import { Inventory } from '@mui/icons-material';
const CourseSelect = (props) => {
    const { t } = useTranslation('coursePlanning');
    const courses = useMemo(() => {
        const result = [];
        if (!props.schoolYearsStatus.data) {
            return result;
        }
        for (const schoolYear of props.schoolYearsStatus.data.schoolYears) {
            for (const course of schoolYear.courses) {
                result.push({
                    label: `${course.name}, ${schoolYear.name}`,
                    value: course.id,
                });
            }
        }
        return result.sort((a, b) => a.label.localeCompare(b.label));
    }, [props.schoolYearsStatus]);
    return (_jsx(Select, { name: props.name, disabled: false, label: _jsxs(Box, { children: [t('selectCourseLabel.beginning'), ' ', _jsx(Typography, { component: "span", color: "secondary.main", children: t(`selectCourseLabel.middle.${props.name}`) }), ' ', t('selectCourseLabel.ending')] }), placeholder: t('selectPlaceholder'), onChange: props.onChange, options: courses, value: props.selectedId, InputProps: {
            startAdornment: _jsx(Inventory, { sx: { mr: 1 } }),
        } }));
};
export default CourseSelect;
